import React, { useState } from 'react'
import { Button } from '../../Common/ui/button'
import { LiaSaveSolid } from 'react-icons/lia'
import { Select, SelectTrigger, SelectContent, SelectItem } from '../../Common/ui/select'
import { Card, Grid, TextField, Modal } from '@mui/material'
import { RadioGroup, RadioGroupItem } from '../../Common/ui/radio-group'
import { IoPersonAdd, IoAddCircleOutline } from 'react-icons/io5'
import { MdOutlineCalendarToday } from 'react-icons/md'
import { BsXCircle } from 'react-icons/bs'
import MultiSelectWithChips from './MultipleSelectionComponent'
import { useMeetingStore } from '../../Containers/MeetingScheduler/Store/MeetingStore'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import TimePicker from '../../Common/ui/timepicker'
import Input from '../../Common/ui/input'
import { useForm } from 'react-hook-form'
import MultiTaskTextArea from '../../Common/ui/multitasktextarea'
import TimezoneSelect from 'react-timezone-select'
import { Checkbox } from '../../Common/ui/checkbox'
import UpcomingEvent from './UpcomingEvents'
import ActionTable from '../../Common/ui/ActionTable'
import { cn } from '../../lib/utils'

const NewMeeting = () => {
    const { register, handleSubmit, formState: { errors, isSubmitting, isLoading }, control } = useForm({ mode: 'onChange' })
    const initialStartTime = new Date()
    const initialEndTime = new Date()
    const [ selectedTimeZone, setSelectedTimeZone ] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)
    const [ title, setTitle ] = useState('')
    const [ description, setDescription ] = useState('')
    const [ priority, setPriority ] = useState('')
    const [ showRepeatingDays, setShowRepeatingDays ] = useState(false)
    const [ selectedDay, setSelectedDay ] = useState([])
    const [ startTime, setStartTime ] = useState(initialStartTime)
    const [ endTime, setEndTime ] = useState(initialEndTime)
    const [ meetingMode, setMeetingMode ] = useState('online')
    const [ meetingPlatform, setMeetingPlatform ] = useState('')
    const [ meetingLink, setMeetingLink ] = useState('')
    const [ location, setLocation ] = useState('')
    const [ agenda, setAgenda ] = useState([])
    const [ minutes, setMinutes ] = useState([])
    const [ risks, setRisks ] = useState([])
    const [ tagGovernance, setTagGovernance ] = useState([])
    const [ tagIssue, setTagIssue ] = useState('')
    const [ tagCompliance, setTagCompliance ] = useState('')
    const [ showOptionalParticipants, setShowOptionalParticipants ] = useState(false)
    const [ optionalParticipants, setOptionalParticipants ] = useState('')
    const [ isCalendarModalOpen, setIsCalendarModalOpen ] = useState(false)
    const [ range, setRange ] = useState({ from: undefined, to: undefined })
    const [ rows, setRows ] = useState([])

    const { createMeeting } = useMeetingStore()

    const handleCancel = () => {
    }

    const handleCustomChange = (value) => {
        setShowRepeatingDays(value)
    }

    const daysOfWeek = [ 'SU', 'M', 'T', 'W', 'TH', 'F', 'SA' ]

    const handleTimeZoneSelect = (timeZone) => {
        setSelectedTimeZone(timeZone)
    }

    const handlePriorityChange = (selectedValue) => {
        setPriority(selectedValue)
    }
    const handleMeetingPlatformChange = (selectedValue) => {
        setMeetingPlatform(selectedValue)
    }
    const handleRiskValuesChange = (value) => {
        setRisks([ ...risks, value ])
    }
    const handleTagGovernanceValuesChange = (value) => {
        setTagGovernance([ ...tagGovernance, value ])
    }
    const handleMinutesofMeetingChange = (value) => {
        setMinutes([ ...minutes, value ])
    }
    const handleAgendaChange = (value) => {
        setAgenda([ ...agenda, value ])
    }
    const handleCloseOptionalParticipants = () => {
        setShowOptionalParticipants(false)
    }

    const handleCalendarIconClick = () => {
        setIsCalendarModalOpen(true)
    }

    const handleCalendarCloseModal = () => {
        setIsCalendarModalOpen(false)
    }
    const handleCalendarCancel = () => {
        setIsCalendarModalOpen(false)
    }
    const handleCalendarSubmit = () => {
        setIsCalendarModalOpen(false)
    }
    const handleStartTimeChange = (time) => {
        setStartTime(time)
    }
    const handleEndTimeChange = (time) => {
        setEndTime(time)
    }
    const handleDayToggle = (day) => {
        if (selectedDay.includes(day)) {
            setSelectedDay(selectedDay.filter(item => item !== day))
        } else {
            setSelectedDay([ ...selectedDay, day ])
        }
    }
    const handleMeetingModeChange = (event) => {
        setMeetingMode(event)
    }

    const handleOptionalAddPeople = () => {
        setShowOptionalParticipants(true)
    }

    const handleOptionalParticipantsChange = (event) => {
        setOptionalParticipants(event.target.value)
    }
    const handleDayClick = (day) => {
        const { from, to } = range
        if (!from) {
            setRange({ from: day, to: undefined })
        } else if (!to && day >= from) {
            setRange({ from, to: day })
        } else {
            setRange({ from: day, to: undefined })
        }
    }

    const eventsData = [
        {
            meetTitle: 'Meeting 1',
            date: '2024-06-06',
            startTime: '2024-06-05T10:00:00.000Z',
            endTime: '2024-06-05T11:00:00.000Z'
        },
        {
            meetTitle: 'Meeting 2',
            date: '2024-06-06',
            startTime: '2024-06-06T13:00:00.000Z',
            endTime: '2024-06-06T14:00:00.000Z'
        }
    ]
    const handleActionTable = (newTask) => {
        setRows([ ...rows, newTask ])
    }
    const handleClickAddTask = () => {
        const newTask = {
            task: '',
            assigneInto: '',
            date: null,
            priority: '',
            formattedRange: ''
        }
        handleActionTable(newTask)
    }
    const handleSave = async () => {
        const meetingData = {
            timeZone: selectedTimeZone,
            title,
            description,
            priority,
            repeatingDays: selectedDay,
            startTime,
            endTime,
            mode: meetingMode,
            platform: meetingPlatform,
            link: meetingLink,
            location,
            agenda,
            minutes,
            risks,
            governanceTags: tagGovernance,
            issueTag: tagIssue,
            complianceTag: tagCompliance,
            optionalParticipants
        }
        try {
            await createMeeting(meetingData)
        } catch (error) {
            console.error(error)
        }
    }
    const columns = [ 'Task Name', 'Assign Into', 'Due Date', 'Priority' ]

    return (
        <div className='new-meeting-container p-5'>
            <Grid container className='flex justify-between'>
                <div className='flex'>
                    <h3 className='text-muted whitespace-nowrap mt-4'>Time Zone</h3>
                    <TimezoneSelect
                        className='p-2 w-300px bg-white text-muted'
                        value={selectedTimeZone}
                        labelStyle='abbrev'
                        displayValue='UTC'
                        onChange={(selectedValue) => handleTimeZoneSelect(selectedValue)}
                    />
                </div>
                <div>
                    <Button variant="outline" onClick={handleCancel} className="m-3">Cancel</Button>
                    <Button variant="default" onClick={handleSubmit(handleSave)} disabled={isSubmitting || isLoading}>
                        <span className="flex items-center">
                            <LiaSaveSolid className="mr-2" size={15} /> Save
                        </span>
                    </Button>
                </div>
            </Grid>
            <Grid container className='h-full px-2'>
                <Grid item xs={12} sm={9} style={{ backgroundColor: 'hsl(var(--card))', maxHeight: '95%', overflowY: 'auto' }} className='p-5 h-full text-muted'>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <Input
                                fullWidth
                                value={title}
                                onValueChange={(e, name) => setTitle(e.target.value)}
                                name="meetingTitle"
                                placeholder="Enter meeting title"
                                rules={{ required: 'Meeting title is required' }}
                                label="Meeting Title"
                                register={register}
                                errors={errors}
                                control={control}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={5} >
                            <Input
                                fullWidth
                                value={description}
                                onValueChange={(e, name) => setDescription(e.target.value)}
                                name="meetingDescription"
                                placeholder="Enter meeting description"
                                rules={{ required: 'Meeting description is required' }}
                                label="Meeting Description"
                                register={register}
                                errors={errors}
                                control={control}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} ><div className='grc-label mb-3'>Priority</div>
                            <Select
                                value={priority}
                                onValueChange={(selectedValue) => handlePriorityChange(selectedValue)}
                                placeholder="Select"
                                rules={{ required: 'Priority is required' }}
                                required
                            >
                                <SelectTrigger>
                                    {priority || 'Select'}
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="Low">Low</SelectItem>
                                    <SelectItem value="Medium">Medium</SelectItem>
                                    <SelectItem value="High">High</SelectItem>
                                </SelectContent>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className='flex justify-between'>
                                <div className='grc-label block mb-1'>Date & Time</div>
                            </div>

                            <div className={'input-grc flex h-9 w-[95%] rounded-lg ring-[1.5px] ring-[hsl(var(--border))] border-none bg-transparent px-3 py-3 text-sm shadow-sm transition-colors file:border-1 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-none focus-visible:outline-none focus-visible:ring-[1.5px] focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50'} style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                <input className='w-full focus:border-transparent focus:outline-none' onClick={handleCalendarIconClick} placeholder='Select date and time' />
                                <MdOutlineCalendarToday style={{
                                    cursor: 'pointer',
                                    color: 'hsl(var(--primary))',
                                    width: '10%'
                                }}
                                onClick={handleCalendarIconClick}
                                />
                            </div>

                            <Modal open={isCalendarModalOpen} onClose={handleCalendarCloseModal} className='p-4'>
                                <div className='text-muted' style={{ position: 'absolute', top: '50%', left: '30%', transform: 'translate(-50%, -50%)', backgroundColor: 'hsl(var(--card))', padding: '20px' }}>
                                    <div className='flex' >
                                        <Card className='rounded-sm p-5 border border-gray-300'>
                                            <DayPicker
                                                style={{ backgroundColor: 'hsl(var(--card))' }}
                                                classNames={{
                                                    months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
                                                    month: 'space-y-3',
                                                    caption_start: 'is-start',
                                                    caption_between: 'is-between',
                                                    caption_end: 'is-end',
                                                    caption: 'flex justify-center pt-1 relative items-center gap-1',
                                                    caption_label: 'flex h-7 text-sm font-medium justify-center items-center grow [.is-multiple_&]:flex',
                                                    caption_dropdowns: 'flex justify-center grow dropdowns pl-7 pr-8',
                                                    multiple_months: 'is-multiple',
                                                    vhidden: 'hidden [.is-between_&]:flex [.is-end_&]:flex [.is-start.is-end_&]:hidden',
                                                    nav: "flex items-center [&:has([name='previous-month'])]:order-first [&:has([name='next-month'])]:order-last",
                                                    nav_button: cn(
                                                        'h-6 w-6 bg-transparent p-0 text-primary'
                                                    ),
                                                    nav_button_previous: 'absolute left-1',
                                                    nav_button_next: 'absolute right-1',
                                                    table: 'w-full border-collapse space-y-1',
                                                    head_row: 'flex',
                                                    head_cell: 'text-primary rounded-md w-8 font-normal text-[0.8rem]',
                                                    row: 'flex w-full mt-2',
                                                    cell: cn(
                                                        'relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent',
                                                        '[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md'
                                                    ),
                                                    day: cn(
                                                        'h-8 w-8 p-0 font-normal aria-selected:opacity-100',
                                                        'rounded-full bg-primary'
                                                    ),
                                                    day_selected:
                                'aria-selected:bg-primary',
                                                    day_range_start: 'rounded-full aria-selected:text-accent',
                                                    day_range_end: 'rounded-full aria-selected:text-accent',
                                                    day_range_middle: 'aria-selected:bg-primary-foreground rounded-[0%] aria-selected:text-primary',
                                                    day_hidden: 'invisible'
                                                }}
                                                mode="range"
                                                selected={range}
                                                onDayClick={handleDayClick}
                                            />
                                        </Card>
                                        <div className='flex flex-col p-3'>
                                            <div>
                                                <p className='font-normal mb-1 mt-2'>From</p>
                                                <TimePicker value={startTime} onTimeChange={handleStartTimeChange} />
                                            </div>
                                            <div>
                                                <p className='font-normal mb-1 mt-10'>To</p>
                                                <TimePicker value={endTime} onTimeChange={handleEndTimeChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full border-t border-gray-300 mt-2 pt-2 flex justify-end">
                                        <Button variant="outline" onClick={handleCalendarCancel} className="mx-3">Cancel</Button>
                                        <Button variant="default" onClick={handleCalendarSubmit} className="mx-3">Submit</Button>
                                    </div>
                                </div>
                            </Modal>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div>
                                {showRepeatingDays && (
                                    <div className='flex absolute mt-7'>
                                        {daysOfWeek.map((day, index) => (
                                            <div
                                                key={index}
                                                className={`selectedays m-2 ${selectedDay.includes(day) ? 'day-box-selected' : 'day-box'}`}
                                                onClick={() => handleDayToggle(day)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {day.toUpperCase()}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div>
                                <div className={!showRepeatingDays ? 'relative mt-10 ml-3 inline-flex items-center' : 'relative mt-20 ml-3 inline-flex items-center'}>
                                    <Checkbox name={'Custom'} checked={showRepeatingDays} onCheckedChange={(e) => handleCustomChange(e, 'Custom')} />
                                    <span className="ml-2">Custom</span>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={4}><div className='grc-label block mb-3'>Meeting mode</div>
                            <RadioGroup onValueChange={handleMeetingModeChange} value={meetingMode} className='flex' >
                                <div className='flex items-center space-x-2'>
                                    <RadioGroupItem value="online" />
                                    <label className='text-l'>Online</label>
                                </div>
                                <div className='flex items-center space-x-2'>
                                    <RadioGroupItem value="hybrid" />
                                    <label className='text-l'>Hybrid</label>
                                </div>
                                <div className='flex items-center space-x-2'>
                                    <RadioGroupItem value="inperson" />
                                    <label className='text-l'>In Person</label>
                                </div>
                            </RadioGroup>
                        </Grid>
                        {meetingMode === 'online' && (
                            <>
                                <Grid item xs={12} sm={4}><div className='grc-label mb-3'>Meeting Platform</div>
                                    <Select
                                        value={meetingPlatform}
                                        onValueChange={(selectedValue) => handleMeetingPlatformChange(selectedValue)}
                                        placeholder="Select"
                                        rules={{ required: 'MeetingPlatform is required' }}
                                        required
                                    >
                                        <SelectTrigger>
                                            {meetingPlatform || 'Select platform'}
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="Zoom">Zoom</SelectItem>
                                            <SelectItem value="Google Meet">Google Meet</SelectItem>
                                            <SelectItem value="Microsoft Teams">Microsoft Teams</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Input
                                        fullWidth
                                        value={meetingLink}
                                        onValueChange={(e, name) => setMeetingLink(e.target.value)}
                                        name="meetinglink"
                                        placeholder="Enter meeting link"
                                        rules={{ required: 'Meeting title is required' }}
                                        label="Meeting Link"
                                        register={register}
                                        errors={errors}
                                        control={control}
                                        required
                                    />
                                </Grid>
                            </>
                        )
                        }
                        {meetingMode === 'inperson' && (
                            <>
                                <Grid item xs={12} sm={4}>
                                    <Input
                                        fullWidth
                                        value={location}
                                        onValueChange={(e, name) => setLocation(e.target.value)}
                                        name="meetinglocation"
                                        placeholder="Enter meeting location"
                                        rules={{ required: 'Meeting title is required' }}
                                        label="Location"
                                        register={register}
                                        errors={errors}
                                        control={control}
                                        required
                                    />
                                </Grid>
                            </>
                        )
                        }
                        { meetingMode === 'hybrid' && (
                            <>
                                <Grid item xs={12} sm={4}><span className='grc-label block mb-3'>Meeting Platform</span>
                                    <Select
                                        value={meetingPlatform}
                                        onValueChange={(selectedValue) => handleMeetingPlatformChange(selectedValue)}
                                        placeholder="Select"
                                        rules={{ required: 'MeetingPlatform is required' }}
                                        required
                                    >
                                        <SelectTrigger>
                                            {meetingPlatform || 'Select platform'}
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="Zoom">Zoom</SelectItem>
                                            <SelectItem value="Google Meet">Google Meet</SelectItem>
                                            <SelectItem value="Microsoft Teams">Microsoft Teams</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Input
                                        fullWidth
                                        value={meetingLink}
                                        onValueChange={(e, name) => setMeetingLink(e.target.value)}
                                        name="meetinglink"
                                        placeholder="Enter meeting link"
                                        register={register}
                                        rules={{ required: 'Meeting title is required' }}
                                        label="Meeting Link"
                                        errors={errors}
                                        control={control}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Input
                                        fullWidth
                                        value={location}
                                        onValueChange={(e, name) => setLocation(e.target.value)}
                                        name="meetingLocation"
                                        placeholder="Enter meeting location"
                                        rules={{ required: 'Meeting location is required' }}
                                        label="Location"
                                        errors={errors}
                                        control={control}
                                        required
                                    />
                                </Grid>
                            </>
                        )
                        }
                        <Grid item xs={12} sm={12}>
                            <div className='grc-label mb-3'>Required Participants</div>
                            <div >
                                <MultiSelectWithChips />
                            </div>
                            <div className="flex ml-2 mt-2 justify-end w-full" onClick={handleOptionalAddPeople}>
                                <IoPersonAdd className='mt-1 text-primary' style={{ cursor: 'pointer' }}/>
                                <span className="ml-2" style={{ cursor: 'pointer' }}>Optional Participants</span>
                            </div>
                            {showOptionalParticipants && (
                                <><Grid item xs={12} sm={12}>
                                    <TextField
                                        fullWidth
                                        label="Optional Participants"
                                        value={optionalParticipants}
                                        onChange={handleOptionalParticipantsChange} />
                                </Grid>
                                <div className="flex ml-2 mt-2 justify-end" onClick={handleCloseOptionalParticipants} >
                                    <BsXCircle className='text-danger'style={{ fontSize: '24px', cursor: 'pointer' }} />
                                    <span className="ml-2" style={{ cursor: 'pointer' }}>Remove Participants</span>
                                </div>
                                </>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className="grc-label flex justify-between mb-3">Add Risk<IoAddCircleOutline className='text-primary' style={{ fontSize: '24px', marginLeft: '10px' }}/></div>
                            <div>
                                <MultiTaskTextArea
                                    values={risks}
                                    risks={risks} setRisks={setRisks}
                                    onValueChange={handleRiskValuesChange}
                                    name="riskInput"
                                    placeholder="Enter risk..."
                                    control={control}
                                    rules={{}}
                                    required
                                    isTasks={true}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <div className="grc-label flex justify-between mb-3 ">Tag Governance<IoAddCircleOutline className='text-primary' style={{ fontSize: '24px', marginLeft: '5px' }}/></div>
                            <div>
                                <MultiTaskTextArea
                                    values={tagGovernance}
                                    tagGovernance={tagGovernance}
                                    setTagGovernance={setTagGovernance}
                                    onValueChange={handleTagGovernanceValuesChange}
                                    name="tagGovernanceInput"
                                    placeholder="Enter tag..."
                                    control={control}
                                    isTagGovernance={true}
                                    rules={{}}
                                    required
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className="grc-label flex justify-between mb-3">Tag Issue<IoAddCircleOutline className='text-primary' style={{ fontSize: '24px', marginLeft: '5px' }}/></div>
                            <Input
                                fullWidth
                                value={tagIssue}
                                onValueChange={(e, name) => setTagIssue(e.target.value)}
                                name="tagissue"
                                placeholder="Add Tag"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className="grc-label flex justify-between mb-3">Tag Compliance<IoAddCircleOutline className='text-primary right-0' style={{ fontSize: '24px' }}/></div>
                            <Input
                                fullWidth
                                value={tagCompliance}
                                onValueChange={(e, name) => setTagCompliance(e.target.value)}
                                name="tagcompliance"
                                placeholder="Add Tag"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12}><div className='grc-label mb-3'>Agenda</div>
                        <MultiTaskTextArea
                            values={agenda}
                            agenda={agenda}
                            setAgenda={setAgenda}
                            onValueChange={handleAgendaChange}
                            name="agenda"
                            placeholder="Enter minutes..."
                            control={control}
                            rules={{}}
                            required
                            isAgenda={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}><div className='grc-label mb-3'>Minutes of Meeting</div>
                        <MultiTaskTextArea
                            values={minutes}
                            minutes={minutes}
                            setMinutes={setMinutes}
                            onValueChange={handleMinutesofMeetingChange}
                            name="minutes"
                            placeholder="Enter minutes..."
                            control={control}
                            rules={{}}
                            required
                            isMinutesOfMeeting={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}><div className='grc-label mb-3'>Action Item</div>
                        <ActionTable columns={columns} rows={rows} handleActionTable={handleActionTable}/>
                        <div onClick={handleClickAddTask} className='text-primary text-right cursor-pointer' cursor="pointer">Add Task</div>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={3}style={{ backgroundColor: 'hsl(var(--card))', maxHeight: '95%', borderLeft: '2px solid hsl(var(--primary-foreground))' }} className='p-5 h-full'>
                    <div>
                        <UpcomingEvent
                            eventsData={eventsData}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default NewMeeting
